import { makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 32,
  },
});

const LogoIcon = () => {
  const classes = useStyles();
  const theme = useTheme();
  const src =
    theme.palette.type === 'dark'
      ? '/YCM-square-dark.png'
      : '/YCM-square-light.png';

  return <img className={classes.img} src={src} alt="YaCadMander" />;
};

export default LogoIcon;
